import {
    Routes
} from '@angular/router';

import {
    Login
} from './features/auth/login/login';

import {
    AppLayout
} from './layout/app-layout/app-layout';

import {
    Dashboard
} from './features/dashboard/dashboard';

import {
    authGuard
} from './core/auth/guards/auth.guard';


export const routes: Routes = [

    /*
     * =========================================================
     * PUBLIC
     * =========================================================
     */

    {
        path: 'login',

        component: Login
    },


    /*
     * El cliente llega aquí escaneando
     * el QR físico de la mesa.
     *
     * NO usa AppLayout.
     * NO usa authGuard.
     */
    {
        path: 'order',

        loadComponent: () =>
            import(
                './features/order/order'
            ).then(
                module =>
                    module.Order
            )
    },


    /*
     * =========================================================
     * ADMINISTRATION
     * =========================================================
     */

    {
        path: '',

        component: AppLayout,

        canActivate: [
            authGuard
        ],

        children: [

            /*
             * =================================================
             * DEFAULT
             * =================================================
             */

            {
                path: '',

                redirectTo: 'dashboard',

                pathMatch: 'full'
            },


            /*
             * =================================================
             * DASHBOARD
             * =================================================
             */

            {
                path: 'dashboard',

                component: Dashboard,

                data: {
                    pageTitle: 'Dashboard'
                }
            },


            /*
             * =================================================
             * BRANCHES
             * =================================================
             */

            {
                path: 'branches',

                data: {
                    pageTitle: 'Sucursales'
                },

                loadComponent: () =>
                    import(
                        './features/branches/branches'
                    ).then(
                        module =>
                            module.Branches
                    )
            },


            /*
             * =================================================
             * DINING AREAS
             * =================================================
             */

            {
                path: 'dining-areas',

                data: {
                    pageTitle: 'Áreas del local'
                },

                loadComponent: () =>
                    import(
                        './features/dining-areas/dining-areas'
                    ).then(
                        module =>
                            module.DiningAreas
                    )
            },


            /*
             * =================================================
             * DINING TABLES
             * =================================================
             */

            {
                path: 'dining-tables',

                data: {
                    pageTitle: 'Mesas'
                },

                loadComponent: () =>
                    import(
                        './features/dining-tables/dining-tables'
                    ).then(
                        module =>
                            module.DiningTables
                    )
            },


            /*
             * =================================================
             * MENU
             * =================================================
             */

            {
                path: 'menu',

                data: {
                    pageTitle: 'Carta y productos'
                },

                loadComponent: () =>
                    import(
                        './features/menu/menu'
                    ).then(
                        module =>
                            module.MenuCatalog
                    )
            }

        ]
    },


    /*
     * =========================================================
     * FALLBACK
     * =========================================================
     */

    {
        path: '**',

        redirectTo: 'login'
    }

];